export const networks_endpoints = {
  endpoints: (build) => ({
    getNetworks: build.query({
      query: () => ({
        url: "network/",
        method: "GET",
      }),
      providesTags: ["Networks"],
    }),
    getNetwork: build.query({
      query: (id) => ({
        url: `network/${id}`,
        method: "GET",
      }),
      providesTags: ["Networks"],
    }),
    createNetwork: build.mutation({
      query: (body) => ({
        url: "network/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Networks"],
    }),
    updateNetwork: build.mutation({
      query: ({ id, body }) => ({
        url: `network/${id}/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "Networks", id: "LIST" }],
    }),
    deleteNetwork: build.mutation({
      query: (id) => ({
        url: `network/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Networks", id: "LIST" }],
    }),
    getTrackingMethods: build.query({
      providesTags: ["TrackingMethods"],
      query: () => ({
        url: "network/tracking-methods/",
        method: "GET",
      }),
    }),
    getTrackedUrlPreview: build.mutation({
      providesTags: ["TrackedURL"],
      query: (body) => ({
        url: "network/preview/",
        method: "POST",
        body,
      }),
    }),
  }),
};
